export default function isIonoUrl (url) {
  const domain = url.match(/.*:\/\/([^\\/]+)/)[1] || '';
  return domain.indexOf('iono') >= 0;
}
